import { hooks, mui, React, ts, ui } from '_core';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  hasBenchmark: boolean;
  context?: ts.types.backtest.BacktestAnaylsisContext;
};

const Form = ({ params, setParams, context, hasBenchmark }: FormProps) => {
  const [selectedHistories, setSelectedHistories] = React.useState(
    params.histories || ([] as ts.enums.HISTORY_ENUM_EXTENDED[])
  );

  const [benchmark, setBenchmark] = React.useState(params.benchmark || null);
  const [withBenchmark, setWithBenchmark] = React.useState(params.with_benchmark || false);
  const [showTargetWeight, setShowTargetWeight] = React.useState(params.showTargetWeight || false);

  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = {
      ...params,
      histories: selectedHistories,
      with_benchmark: withBenchmark,
      showTargetWeight: showTargetWeight,
    };
    if (withBenchmark) data.benchmark = benchmark;
    else if (data.benchmark) delete data.benchmark;

    setParams(data);
  }, [selectedHistories, withBenchmark, benchmark, showTargetWeight]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mt={2}>
        <ui.WidgetHistories<true>
          multiple
          context={context}
          value={selectedHistories}
          setValue={setSelectedHistories}
        />
      </mui.core.Box>

      {hasBenchmark && (
        <>
          <mui.core.Box mt={3}>
            <mui.core.FormControlLabel
              control={
                <mui.core.Switch
                  size="small"
                  checked={withBenchmark}
                  onChange={() => setWithBenchmark(!withBenchmark)}
                />
              }
              label="Has benchmark"
            />
          </mui.core.Box>

          {params.isBasket && (
            <mui.core.Box mt={3}>
              <mui.core.FormControlLabel
                control={
                  <mui.core.Switch
                    size="small"
                    checked={showTargetWeight}
                    onChange={() => setShowTargetWeight(!showTargetWeight)}
                  />
                }
                label="Show target weight returns"
              />
            </mui.core.Box>
          )}

          {withBenchmark && (
            <mui.core.Box mt={2}>
              <ui.Benchmark
                value={benchmark || undefined}
                setValue={setBenchmark}
                universeContextPath={'$universe.handle'}
                hiddenOptions={[ts.enums.BENCHMARK_TYPES_ENUM.DS_INDEX]}
                universeIdPath={'definition.universe_id'}
              />
            </mui.core.Box>
          )}
        </>
      )}
    </mui.core.Box>
  );
};

export default Form;
